<template>
  <div class="header">
    <div class="content-continer">
      <p class="logo left">
        <router-link to="/home" style="background: none;line-height:70px;"><img src="../assets/logo.png"></router-link>
      </p>
      <ul>
        <li>
          <router-link to="/home">首页</router-link>
        </li>
        <li>
          <router-link to="/about">了解CRC</router-link>
        </li>
        <li>
          <router-link to="/processes">业务流程</router-link>
        </li>
        <!-- <li>
          <router-link to="/bar2" >CRC招聘信息</router-link>
        </li>
        <li>
          <router-link to="/bar3">CRC人才中心</router-link>
        </li>
        <li>
          <router-link to="/bar4">加入CRC</router-link>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Header",
    data() {
      return {
        msg: "Welcome to Your Vue.js App"
      };
    }
  };
</script>
<style scoped>
  .header {
    height: 70px;
    line-height: 70px;
    background: #fff;
    box-shadow: 0px 1px 21px 0px rgba(202, 202, 202, 0.29);
  }

  .header ul {
    float: right;
    list-style-type: none;
  }

  .header ul li {
    display: inline-block;
    width: 130px;
    height: 40px;
    text-align: center;
  }

  .active {
    background: rgba(54, 114, 191, 1);
    border-radius: 4px;
    color: #fff !important;
    line-height: 40px;
  }

  .header a {
    color: #333;
    font-size: 16px;
    text-decoration: none;
    display: block;
    width: 100%;
    height: 100%;

  }

  .logo img {
    vertical-align: middle;
  }

  .logo-name {
    font-size: 20px;
    font-family: SourceHanSansCN-Regular;
    font-weight: bold;
    color: rgba(55, 113, 202, 1);
    margin-left: 12px;
  }
</style>


// WEBPACK FOOTER //
// src/components/header.vue